import { initializeAuth, getSubdomainFromPath } from '@attensi/auth'
import { AUTH_URL, API_TOKEN, BACKEND_URL, LOGIN_URL } from '@/consts'

// Self-executing: sets auth config at module evaluation time.
// This module must be imported before any code that calls getConfig()
// (e.g. router, unleashClient) to avoid a race condition.
initializeAuth({
  authUrl: AUTH_URL,
  backendApiToken: API_TOKEN,
  backendUrl: BACKEND_URL,
  loginUrl: LOGIN_URL,
  subdomain: getSubdomainFromPath(),
})
